import { render, staticRenderFns } from "./FileAddView.vue?vue&type=template&id=f3ce3bc6&scoped=true&"
import script from "./FileAddView.vue?vue&type=script&lang=js&"
export * from "./FileAddView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=f3ce3bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ce3bc6",
  null
  
)

export default component.exports